<template>
  <b-container id="org-chart-filter" fluid>
    <b-row class="w-100">
      <b-col md="8">
        <div>
          <strong>
            <slot name="title">CFCL's per organisation</slot>
          </strong>
        </div>
      </b-col>
      <b-col md="4">
        <b-badge pill variant="info">
          {{ numSectors }}
          <slot name="category">Organisations.</slot>
        </b-badge>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8">
        <div class="org-chart">
          <app-chart
            :chart-data="displayStats"
            :options="options"
            ref="chartFilter"
          ></app-chart>
          <div class="absolute-center text-center">
            <b-badge class="p-1" :variant="num > 0 ? 'success' : 'danger'">
              {{ num }}
              <br />
              <span>{{ cfclStatus }}</span>
            </b-badge>
          </div>
        </div>
      </b-col>
      <b-col md="4" class="pl-0">
        <div v-if="selected || selectedItem" class="pt-2">
          <strong>
           {{ $t('dashboard.chart.filtered-by') }}
            <br />
            {{ selectedLabel }}
          </strong>
          <span
            class="clear-selection ml-1"
            @click="clearSelected()"
            v-b-tooltip.hover.right
            :title="$t('dashboard.chart.clear-selection')"
          >
            <i class="fas fa-times-circle"></i>
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="float-right">
        <div>
          <small>
            <slot name="instructions"
              >Click on chart to filter applications.</slot
            >
          </small>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Doughnut from "@/components/charts/Doughnut";
import * as _ from "lodash";
import randomColor from "randomcolor";
export default {
  props: ["stats", "num", "selectedItem", "status"],
  data() {
    return {
      selected: null,
      hoverElement: null
    };
  },
  computed: {
    cfclStatus(){
      if(this.status === '0'){
        return 'CFCL'
      }
      if(this.status === '2'){
        return 'IFC'
      }
      else {
        return 'CFCL/IFC'
      }
    },
    selectedLabel() {
      if (this.selected) {
        return this.selected._model.label;
      }
      if (this.selectedItem) {
        return this.selectedItem;
      }
      return null;
    },
    numSectors() {
      return this.labels.length;
    },
    options() {
      let _vm = this;
      return {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: 50,
        onClick: function(e, elements) {
          if (elements.length) {
            this.update();
            let element = elements[0];
            _vm.$emit("filter", element._model.label);
            _vm.selected = element;
          }
        },
        onHover: function(e, elements) {
          if (elements.length) {
            elements[0]._chart.canvas.style.cursor = "pointer";
            _vm.hoverElement = elements[0];
            this.update();
            _vm.hoverElement._model.outerRadius += 5;
          } else {
            e.currentTarget.style.cursor = "default";
            if (_vm.hoverElement) {
              this.update();
              _vm.hoverElement = null;
            }
          }
        },
        layout: {
          padding: 7
        },
        tooltips: {
          titleFontSize: 20,
          xPadding: 10,
          yPadding: 10
        },
        legend: {
          display: false
        },
        borderAlign: "inner"
      };
    },
    numOrgs() {
      return this.labels.length;
    },
    labels() {
      return _.keys(this.stats);
    },
    colors() {
      let numOrgs = this.labels.length;
      return randomColor({
        count: numOrgs,
        hue: "random"
      });
    },
    legend() {
      let legends = [];
      for (let i = 0; i < this.labels.length; i++) {
        let label = this.labels[i];
        let color = this.colors[i];
        let val = this.stats[label];
        legends.push({ name: label, color: color, val: val });
      }
      return legends;
    },
    displayStats() {
      let labels = _.keys(this.stats);
      let data = _.map(this.stats, org => {
        return org;
      });

      return {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.colors,
            data: data
          }
        ]
      };
    }
  },
  components: {
    appChart: Doughnut
  },
  methods: {
    clearSelected() {
      let element = this.selected;
      let chartFilter = this.$refs.chartFilter;
      chartFilter.$data._chart.update();
      this.selected = null;
      this.$emit("filter", null);
    }
  },
  created() {
    let _vm = this;
    _vm.$root.$on("clear-filters", () => {
      if (_vm.selected) {
        let element = _vm.selected;
        let chartFilter = _vm.$refs.chartFilter;
        if(chartFilter){
          element._model.outerRadius -= 7;
          chartFilter.$data._chart.update();
        }
        _vm.selected = null;
      }
    });
  }
};
</script>
<style scoped>
#org-chart-filter {
  padding: 0.5em;
  border: 1px solid lightgrey;
  border-radius: 4px;
  width: 100%;
}
#org-chart-filter:hover {
  cursor: pointer;
}
.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
}

.text-center {
  text-align: center;
}
.clear-selection {
  color: #dc3545;
  cursor: pointer;
}
</style>
